/* eslint-disable react/no-unknown-property */
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import TenantProfile from 'aurora-images/avatar_profile.svg';

import { ADGMPanel } from 'aurora-components';
// import ADGMItemDetails from 'aurora-components/ADGMItemDetails/ADGMItemDetails';
import { keyEmptyCheck } from 'aurora-utils/utils';
import styles from './styles';

function PaymentInitiator(props) {
  const { classes, application, title } = props;
  const locale = localStorage.getItem('lang');

  return (
    <>
      <ADGMPanel title={keyEmptyCheck(title)}>
        <div className={classes.container}>
          <div item xs={12} className={classes.flexCenter}>
            <Avatar alt='profile' src={TenantProfile} className={classes.ownerAvatarimg} />
            <div className={classes.textRow}>
              <Typography variant='h6' component='h6'>
                {keyEmptyCheck('Name')}
              </Typography>
              <Typography variant='h6' component='h3'>
                {locale === 'ar'
                  ? application?.applicationDetails?.initiatorNameAr
                  : application?.applicationDetails?.initiatorName}
              </Typography>
            </div>
          </div>

          {/* <div className={classes.applicationId}>
            <ADGMItemDetails label='reference_ID' value={application?.applicationDetails?.applicationNumber} />
          </div> */}
        </div>
      </ADGMPanel>
    </>
  );
}

PaymentInitiator.propTypes = {
  classes: PropTypes.object.isRequired,
  application: PropTypes.object.isRequired,
  title: PropTypes.string,
};
PaymentInitiator.defaultProps = {
  title: 'initiated_by_text',
};
export default withStyles(styles)(PaymentInitiator);
